import React, { useState } from 'react';
import PageHeader from '../../components/PageHeader';
import { useTranslation } from 'react-i18next';
import Hero from '../../components/Hero';
import PageIntro from '../../components/PageIntro';
import Quotes from '../../components/Quotes';

const Home = () => {
    const { t } = useTranslation();
    const tr = (key) => {
        return t(`homePage:${key}`);
    };


    return (
        <div className="min-h-screen">
            <PageIntro description={tr('pageDescription')} />
            <Hero />
            <Quotes />
         
        </div>
    );
};

export default Home;
